import { columnsheadId } from '../../universal/columnshead';
import WebUniversalNewEx, { initDataType, WUExtendPropsType } from '../../system/WebUniversalNewEx';
import ExpandTypeEdit from './ExpandTypeEdit';
import { useEffect, useRef, useState } from 'react';
import { Button, Col, Form, Modal, Row, Select, Space, Tooltip } from 'antd';
import getList from '../../universal/getList';
import fetchApi from '../../../utils/api/fetchApi';
import systemConfig from '../../../config/systematic';
import antMessage from '../../../utils/extend/AntdNotification';
import { showCustomNotification, useNotificationInstance } from '../../../utils/extend/AntdNotificationEx';

export default function ExpandType(props: any) {

    const ref = useRef<any>(undefined);
    const [form] = Form.useForm(); //form 
    const notificationApi = useNotificationInstance();

    //规格窗口
    const [relateProductVisible, setRelateProductVisible] = useState(false);

    const [productData, setProductData] = useState<any>();

    const [expandTypeId, setExpandTypeId] = useState<any>();

    /** 需求类型数据 */
    const [expandCategoryData, setExpandCategoryData] = useState<any>();
    const [expandCategoryIdData, setExpandCategoryIdData] = useState<any>();

    /** api服务id */
    const apiId = 'expandType';

    /** 后端数据wmService */
    let wmService: any = systemConfig.wmService;

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            // handleChangeOne = ref.current.handleChangeOne;
        }
        //同步获取数据 async - await
        const fetchData = async () => {

            fetchApi.GET(wmService, {
                apiId: "expandCategory",
                apiExtend: 'showList',
            }).then(async res => {
                if (res.success) {
                    await setNewData(res.data, setExpandCategoryData);
                }
            })
        }

        fetchData();
        //禁用规则
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); //初始化数据

    const setNewData = async (rows: any, setData: any) => {
        let finalData: any = [];
        let childrenData: any = [];

        await fetchApi.GET(wmService, {
            apiId: "generalData",
            apiExtend: 'showList',
            apiVariable: "menuWarehouseRequireMent",
        }).then(res => {
            if (res.success) {
                let rowsData = res.data;
                for (let i = 0; i < rowsData.length; i++) {
                    for (let j = 0; j < rows.length; j++) {
                        if (rows[j].menuWarehouseRequireMentId === rowsData[i].id) {
                            childrenData.push({
                                label: rows[j].expandCategoryName, value: rows[j].id
                            })
                        }
                    }
                    finalData.push({
                        label: rowsData[i].name,
                        title: rowsData[i].name,
                        options: childrenData
                    })
                    childrenData = [];
                }
            }
        })

        setData(finalData);
    }

    const initData = async () => {
        const currentData: initDataType = {
            apiId,
            sendPageData: {
                expandCategoryId: expandCategoryIdData
            }
        }
        ref.current.initData(currentData);
    }

    //查看不同分类的菜式
    const expandCategoryChange = (e: any) => {
        setExpandCategoryIdData(e);
        const currentData: initDataType = {
            apiId,
            sendPageData: {
                expandCategoryId: e
            }
        }
        ref.current.initData(currentData);
    }

    //打开关联材料窗口
    const handleRelateProduct = (record: any) => {
        setExpandTypeId(record.id);
        setRelateProductVisible(true);
    };

    //关闭关联材料窗口
    const onCloseRelateProduct = async () => {
        form.setFieldsValue({ productId: null });
        setRelateProductVisible(false);
        await initData();
    }

    //清除关联材料
    const cancelRelateProduct = (record: any) => {
        fetchApi.PUT(wmService, {
            apiId,
            apiExtend: 'cancelRelation',
            allData: record
        }).then(async res => {
            if (res.success) {
                antMessage('success', '清除成功', 'success');
                await initData();
            }
        })
    };

    const handleOk = (e: any) => {
        form.validateFields() //数据校验
            .then(async (values: any) => {
                // console.log(values);
                fetchApi.POST(wmService, {
                    apiId,
                    apiExtend: 'relationProduct',
                    apiData: {
                        ...values,
                        id: expandTypeId,
                        mountDataOptions: {
                            userMount: {
                                isDept: true
                            }
                        }
                    }
                }).then(res => {
                    if (res.success) {
                        antMessage('success', '添加成功', 'success');
                        onCloseRelateProduct();
                    }
                }).catch(err => {
                    antMessage('error', '错误，无法保存', err.message + ' | status:' + err.errors.status);
                })
            })
            .catch((err: any) => {
                showCustomNotification(notificationApi!, {
                    type: 'warning',
                    message: "无法通过数据校验",
                    description: "请输入所需数据!"
                });
            });
    };

    //表头
    const columnsHead = [
        {
            title: '需求类型',
            dataIndex: 'expandCategoryName',
            render: (text: any, record: any) => {
                return (
                    <div>{record.expandCategory.expandCategoryName}</div>
                )
            }
        },
        {
            title: '需求内容',
            dataIndex: 'expandTypeName',
            width: 500,
            render: (text: any) => <Tooltip placement="topLeft" title={text}>{
                (typeof text !== "undefined" && text !== null) ?
                    (text.length >= 50 ? text.substring(0, 50) + '......' : text)
                    : ''
            }</Tooltip>
        },
        {
            title: '关联材料',
            dataIndex: 'relateProduct',
            key: 'relateProduct',
            render: (text: any, record: any) => {
                if (record.expandCategory.isRelation) {
                    return (
                        <Space size="small">
                            <Button size={"small"} type="primary" onClick={() => handleRelateProduct(record)}>{'关联材料'}</Button>
                        </Space>
                    )
                }
            }
        },
        {
            title: '当前关联材料',
            dataIndex: 'productName',
            key: 'productName',
            render: (text: any, record: any) => {
                if (record.product) {
                    return (
                        <div>{record.product.productName}&nbsp;&nbsp;&nbsp;&nbsp;<Button size={"small"} type="primary" onClick={() => cancelRelateProduct(record)}>{'清除关联'}</Button></div>
                    )
                }
            }
        }
        // {
        //     title: '排序',
        //     dataIndex: 'sortBy',
        // },
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '需求内容',
        apiId,
        showStates: true,
        columns,
        pagination: true,
        EditComponent: ExpandTypeEdit,
        // mountDataOptions: {
        //     userMount: {
        //         isDept: true
        //     }
        // }
    };

    return (
        <>
            <Modal
                title="关联材料"
                open={relateProductVisible}
                onOk={handleOk}
                onCancel={onCloseRelateProduct}
                maskClosable={false}
                width={800}
            >
                <Form
                    form={form}
                    name="Edit"
                >
                    <Row gutter={[8, 0]}>
                        <Col span={24}>
                            <Form.Item
                                label="选择产品"
                                name="productId"
                                rules={[{ required: true, message: '请选择产品!' }]}>
                                <Select
                                    onSearch={(e) => getList.searchEx('product', setProductData, e, productData, {
                                        andWhereObj: {
                                            mountDataOptions: {
                                                userMount: {
                                                    isDept: true,
                                                    isUserAreas: true
                                                }
                                            }
                                        },
                                    })}
                                    options={getList.generalSelcetOption(productData, "productName", "id", aa)}
                                    showSearch
                                    placeholder="产品"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) => { return true }}
                                >
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Modal>

            <Select
                showSearch
                allowClear
                defaultValue="所有类型"
                onChange={expandCategoryChange}
                style={{ width: '150px' }}
                placeholder="需求类型"
                optionFilterProp="children"
                filterOption={(input, option: any) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                options={expandCategoryData}
            >
            </Select>
            <span>&nbsp;&nbsp;</span>
            <WebUniversalNewEx props={extendProps} ref={ref}></WebUniversalNewEx>
        </>
    )
}

const aa = (item: any) => {
    return `${item.productName} ${item.productUnit.productUnitName}`
}